import { Component, OnInit, ViewEncapsulation, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.scss']
})
export class ConfirmDeleteDialogComponent implements OnInit {
  public title = '';
  public alertMode = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
  ) { }

  ngOnInit() {
    if (this.data.title === undefined) {
      this.title = 'คุณแน่ใจหรือไม่ที่จะลบ';
    } else {
      this.title = this.data.title;
    }

    if (this.data.alertMode !== undefined) {
      this.alertMode = this.data.alertMode;
    }
  }
  onClose() {
    this.dialogRef.close({ status: false });
  }
  onSave() {
    this.dialogRef.close({ status: true });
  }
}
